import { Stack } from "@mui/material";
import { PrimaryEditLink } from "react-common-ui-library/FPACT/Navigation";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  ACCOUNT_CREATION_ROUTE,
  ACCOUNT_SETUP_ROUTE,
  CIRCLE_UNICODE,
  SPACING_2_5__2,
  SPACING_4_3,
  SUBTITLE,
} from "../../../Constants/CommonConstants";
import {
  REVIEW_YOUR_INFORMATION_ACCOUNT_SETUP_SECTION,
  REVIEW_YOUR_INFORMATION_ACCOUNT_SETUP_SECTION_EDIT,
  REVIEW_YOUR_INFORMATION_EDIT,
  REVIEW_YOUR_INFORMATION_PASSWORD,
  REVIEW_YOUR_INFORMATION_USERNAME,
} from "../../../Constants/ReviewYourInformationConstants";
import { manageAccountCreationSelector } from "../../../Selectors/AccountCreationSelector";
import { StyledReviewSectionHeader } from "../../../Styles/AccountCreation/ReviewYourInformation/ReviewYourInformationStyles";
import { StyledTypographyHeader } from "../../../Styles/Common/CommonStyles";
import ReviewFieldDisplay from "./ReviewFieldDisplay";

/**
 * @description contains information that is saved in Account setup .
 * @returns {ReactNode} Render Account Setup section with Username and Password
 */
const ReviewAccountSetupSection = () => {
  const navigate = useNavigate();

  const intl = useIntl();

  const { userName, password } = useSelector((state) =>
    manageAccountCreationSelector(state),
  );

  const navigateToAccountSetupPage = () => {
    navigate(`/${ACCOUNT_CREATION_ROUTE}/${ACCOUNT_SETUP_ROUTE}`);
  };

  return (
    <Stack gap={SPACING_4_3}>
      <StyledReviewSectionHeader>
        <StyledTypographyHeader
          id={REVIEW_YOUR_INFORMATION_ACCOUNT_SETUP_SECTION}
          variant={SUBTITLE}
          fontWeight={600}
        >
          {intl.formatMessage({
            id: REVIEW_YOUR_INFORMATION_ACCOUNT_SETUP_SECTION,
          })}
        </StyledTypographyHeader>
        <PrimaryEditLink
          onClick={navigateToAccountSetupPage}
          label={intl.formatMessage({
            id: REVIEW_YOUR_INFORMATION_EDIT,
          })}
          id={REVIEW_YOUR_INFORMATION_ACCOUNT_SETUP_SECTION_EDIT}
        />
      </StyledReviewSectionHeader>
      <Stack gap={SPACING_2_5__2}>
        <ReviewFieldDisplay
          fieldLabelId={REVIEW_YOUR_INFORMATION_USERNAME}
          fieldData={userName}
        />
        <ReviewFieldDisplay
          fieldLabelId={REVIEW_YOUR_INFORMATION_PASSWORD}
          fieldData={CIRCLE_UNICODE.repeat(password.length)}
        />
      </Stack>
    </Stack>
  );
};

export default ReviewAccountSetupSection;
